import React, { Component, createContext, useContext } from "react";
import { AuthContext } from "./AuthContext";
import { db } from "../config/Firebase";
const DataContext = createContext();
const values = ["level_1", "level_2", "level_3"];

export const useData = () => useContext(DataContext);
class DataContextProvider extends Component {
  static contextType = AuthContext;
  state = {
    level_1: {
      video: [
        {
          type: "video",
          src: "https://firebasestorage.googleapis.com/v0/b/bitstarter1.appspot.com/o/level_1%2Fvideo%2Fynmn3e31ed?alt=media&token=86b17494-c739-4742-b130-bbd4b1b74d05",
        },
      ],
      icon: [
        {
          type: "image",
          src: "https://firebasestorage.googleapis.com/v0/b/bitstarter1.appspot.com/o/level_1%2Ficon%2F564bbtsbe1b?alt=media&token=edb9de69-a6ca-49f3-b4c1-83e33a24ee4a",
        },
      ],
      points: "10",
      name: "Noob",
    },
    level_2: {
      video: [
        {
          src: "https://firebasestorage.googleapis.com/v0/b/bitstarter1.appspot.com/o/level_2%2Fvideo%2Fup9682s8vo8?alt=media&token=1813304c-d518-4f09-b36c-66d84857493e",
          type: "video",
        },
      ],
      icon: [
        {
          src: "https://firebasestorage.googleapis.com/v0/b/bitstarter1.appspot.com/o/level_2%2Ficon%2Fey0rmrfkhl6?alt=media&token=78b6b3f2-6d57-4123-a303-ce634627b4dd",
          type: "image",
        },
      ],
      name: "Hodlr",
      points: "10",
    },
    level_3: {
      icon: [
        {
          type: "image",
          src: "https://firebasestorage.googleapis.com/v0/b/bitstarter1.appspot.com/o/level_3%2Ficon%2Frivkspgr38g?alt=media&token=d7f1e92e-f831-4ba9-b058-1b870d6179db",
        },
      ],
      points: "10",
      video: [
        {
          type: "video",
          src: "https://firebasestorage.googleapis.com/v0/b/bitstarter1.appspot.com/o/level_3%2Fvideo%2F9f5lotyl3rt?alt=media&token=548a8703-9834-4e3e-9286-c7377e028547",
        },
      ],
      name: "Adept",
    },
    pageLoaded: false,
    allLoaded: false,
  };
  getData = (type, typeLoaded) => {
    this.setState({ [typeLoaded]: false });
    const onSnapshot = (snapShot) => {
      this.setState({ [type]: snapShot.data(), [typeLoaded]: true });
    };
    this[type + "Unsub"] = db
      .collection("levels")
      .doc(type)
      .onSnapshot(onSnapshot);
  };
  updateData = (type, id, update, resolve, reject) => {
    db.collection(type).doc(id).update(update).then(resolve).catch(reject);
  };
  addData = (type, add, resolve, reject) => {
    db.collection(type).add(add).then(resolve).catch(reject);
  };
  componentDidMount() {
    window.addEventListener("load", () => this.setState({ pageLoaded: true }));
  }
  UNSAFE_componentWillUpdate(_prevProps, prevState) {
    const { pageLoaded, allLoaded } = prevState;
    if (this.context.presistant && pageLoaded && !allLoaded) {
      this.setState({ allLoaded: true });
      const loaders = document.querySelectorAll(".loader_wrapper");
      loaders.forEach((el) => el.classList.add("hide"));
      setTimeout(() => {
        loaders.forEach((el) => el.remove());
      }, 300);
    }
  }
  get = (a) => a.current.value;
  render() {
    return (
      <DataContext.Provider value={{ values, ...this.state, ...this }}>
        {this.context.presistant && this.props.children}
      </DataContext.Provider>
    );
  }
}

export default DataContextProvider;
